export default '6.11.1';